<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { ChangelogType } from '.';
import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';
import { DetailsBuilderContract } from '@/components/builder/details';
import Changelog from '@/components/common/dynamic-changelog/Changelog.vue';
import properties from '../../properties';

defineOptions({
    name: 'ChangelogBlueprint',
    components: {
        ...properties,
    },
});

const props = defineProps({
  "blueprint": null,
  "details": null,
  "parent": null
});

const route = useRoute();

const blueprint = computed(() => props.blueprint);
const licence = computed(() => route.params.licence as string);
const publicId = computed(() => route.params.publicId as string);
const design = computed(() => props.details.designMode());
</script>

<template>
    <dynamic-details-component-wrapper :details="details" :parent="parent" :blueprint="blueprint">
        <template #default>
            <changelog :blueprint-name="blueprint.name" :design="design" :entity-type="licence" :id="publicId" />
        </template>
        <template #properties>
            <field-name v-model="blueprint.name" />
            <dynamic-details-accordion>
                <dynamic-details-accordion-item icon="far fa-table" :header="$t('[[[Prezentacja]]]')">
                    <field-visible :details="details" :blueprint="blueprint" />
                </dynamic-details-accordion-item>
            </dynamic-details-accordion>
        </template>
    </dynamic-details-component-wrapper>
</template>
